export const enum ProviderProductType {
    LOAN = "loan",
    CREDIT = "credit"
}
